import { ClassificationTask } from '@idea2app/ai-work-order-service';

import { TableModel } from './Base';
import userStore from './User';

/**
 * Task Status Enum
 * Matches `TaskStatus` from `@idea2app/ai-work-order-service`
 */
export enum TaskStatus {
    InProgress = 'in_progress',
    Completed = 'completed',
    Failed = 'failed'
}

/**
 * AI Analysis Capability Enum
 * Matches `AIAnalysisCapability` from `@idea2app/ai-work-order-service`
 */
export enum AIAnalysisCapability {
    IntelligentClassification = 'intelligent_classification',
    DuplicateRecovery = 'duplicate_recovery',
    SensitiveWorkOrder = 'sensitive_work_order',
    ResponsibleWorkOrder = 'responsible_work_order'
}

export const TaskStatusLabels: Record<TaskStatus, string> = {
    [TaskStatus.InProgress]: 'task_in_progress',
    [TaskStatus.Completed]: 'task_completed',
    [TaskStatus.Failed]: 'task_failed'
};

export const TaskStatusColors: Record<TaskStatus, string> = {
    [TaskStatus.InProgress]: 'primary',
    [TaskStatus.Completed]: 'success',
    [TaskStatus.Failed]: 'danger'
};

export const AICapabilityLabels: Record<AIAnalysisCapability, string> = {
    [AIAnalysisCapability.IntelligentClassification]:
        'ai_intelligent_classification',
    [AIAnalysisCapability.DuplicateRecovery]: 'ai_duplicate_recovery',
    [AIAnalysisCapability.SensitiveWorkOrder]: 'ai_sensitive_work_order',
    [AIAnalysisCapability.ResponsibleWorkOrder]: 'ai_responsible_work_order'
};

export class ClassificationTaskModel extends TableModel<ClassificationTask> {
    baseURI = 'task/classification';
    client = userStore.client;
}

export default new ClassificationTaskModel();
